"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseParams = void 0;
exports.createParam = createParam;
exports.joinUrl = joinUrl;
exports.modifyParams = modifyParams;
var queryParams_1 = require("../queryParams/queryParams");
var TRIM_RE = /^\/+|\/+$/g;
var TRIM_RIGHT_RE = /\/+$/g;
var TRIM_LEFT_RE = /^\/+/g;
var trimFn = function (re) { return function (str) { return str.replace(re, ''); }; };
var trim = trimFn(TRIM_RE);
var trimRight = trimFn(TRIM_RIGHT_RE);
var trimLeft = trimFn(TRIM_LEFT_RE);
exports.parseParams = queryParams_1.getQueryParams;
function createParam(obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj)
        .map(function (key) {
        var value = obj[key];
        if (value === undefined) {
            return undefined;
        }
        return "".concat(key, "=").concat(encodeURIComponent(value));
    })
        .filter(Boolean)
        .join('&');
}
function joinUrl() {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    if (parts.length === 0) {
        return '';
    }
    if (parts.length === 1) {
        return parts[0];
    }
    var _a = [parts[0], parts.slice(1, parts.length - 1), parts[parts.length - 1]], start = _a[0], other = _a[1], last = _a[2];
    start = trimRight(start);
    last = trimLeft(last);
    other = other.map(trim);
    return __spreadArray(__spreadArray([start], other, true), [last], false).join('/');
}
// export function modifyParams(modifications: object): string;
function modifyParams(modifications, search) {
    if (search === void 0) { search = location.search; }
    var params = (0, exports.parseParams)(search);
    var prefix = search.startsWith('?') ? '?' : '';
    return prefix + createParam(__assign(__assign({}, params), modifications));
}
//# sourceMappingURL=url.js.map